import { useState, useEffect } from "react";
import { useUserInfo } from "@redux/slices/userInfoSlice";

export function useTokenPresence() {
  const [hasToken, setHasToken] = useState<boolean | null>(null); // null = still checking
  const userInfo = useUserInfo();

  useEffect(() => {
    const checkTokenPresence = async () => {
      try {
        const token = await userInfo.getToken();
        setHasToken(token !== null);
      } catch (error) {
        console.error("Failed to read token:", error);
        setHasToken(false);
      }
    };

    checkTokenPresence();
  }, []);

  return hasToken;
}
